import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { ReservationSearchHeaderAndTab, SearchResultTable } from "../../_shared";
import {
	Calendar,
	CalendarAction,
	CalendarHeader,
	CalendarPanel,
	CalendarPanelLayout,
	CalendarPanelReservationContent,
} from "../../_shared/components/calendar";
import * as Model from "../model";

type Props = {
	hotelID: string;
};

export const ManagementReservationSearchCalendar = ({ hotelID }: Props) => {
	/**
	 * 初期化
	 */
	const {
		//
		// readonly
		viewData,
		//
		// searchable
		searchModel,
		// 月の切り替え
		onPrevMonth,
		onNextMonth,
		// 予約タイプかつ日付の選択
		onSelectReservationTypeWithDate,
	} = Model.UseCase.useInitialized({ hotelID });

	return (
		<FeatureIslandContainer>
			<ReservationSearchHeaderAndTab hotelID={hotelID} />

			<FeatureIslandMainWithBackGround>
				<Calendar
					headerChildren={
						<CalendarHeader
							year={searchModel.searchCondition.year}
							month={searchModel.searchCondition.month}
							prevActionChildren={<CalendarAction type="prev" onActionCallback={onPrevMonth} />}
							nextActionChildren={<CalendarAction type="next" onActionCallback={onNextMonth} />}
						/>
					}
					contentChildren={
						<CalendarPanelLayout>
							{viewData.calendarReservationList.map((item, index) =>
								item ? (
									<CalendarPanel
										key={index}
										date={item.date}
										cInDatePanelContentChildren={
											<CalendarPanelReservationContent
												text="C/In"
												countText={item.cInDate.countText}
												selected={
													item.date === searchModel.searchCondition.selectedDate &&
													item.cInDate.reservationType === searchModel.selectedReservationType
												}
												onSelectCallback={() =>
													onSelectReservationTypeWithDate(
														item.date,
														item.cInDate.reservationType,
													)
												}
											/>
										}
										cOutDatePanelContentChildren={
											<CalendarPanelReservationContent
												text="C/Out"
												countText={item.cOutDate.countText}
												selected={
													item.date === searchModel.searchCondition.selectedDate &&
													item.cOutDate.reservationType ===
														searchModel.selectedReservationType
												}
												onSelectCallback={() =>
													onSelectReservationTypeWithDate(
														item.date,
														item.cOutDate.reservationType,
													)
												}
											/>
										}
										stayDatePanelContentChildren={
											<CalendarPanelReservationContent
												text="宿泊"
												countText={item.stayDate.countText}
												selected={
													item.date === searchModel.searchCondition.selectedDate &&
													item.stayDate.reservationType ===
														searchModel.selectedReservationType
												}
												onSelectCallback={() =>
													onSelectReservationTypeWithDate(
														item.date,
														item.stayDate.reservationType,
													)
												}
											/>
										}
										dayTripCInDatePanelContentChildren={
											<CalendarPanelReservationContent
												text="日帰り"
												countText={item.dayTripOfCInDate.countText}
												selected={
													item.date === searchModel.searchCondition.selectedDate &&
													item.dayTripOfCInDate.reservationType ===
														searchModel.selectedReservationType
												}
												onSelectCallback={() =>
													onSelectReservationTypeWithDate(
														item.date,
														item.dayTripOfCInDate.reservationType,
													)
												}
											/>
										}
									/>
								) : (
									<div key={index} />
								),
							)}
						</CalendarPanelLayout>
					}
				/>

				{/* 検索結果テーブル */}
				<div className="mt-10">
					<SearchResultTable
						aboutChildren={
							<div>
								<p className="font-semibold">{viewData.searchResultTableData.helpText}</p>
							</div>
						}
						rows={viewData.searchResultTableData.rowList}
					/>
				</div>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};
